import { color } from '@amcharts/amcharts5';
import { AxisRenderer, DateAxis, XYCursor } from '@amcharts/amcharts5/xy';

import { Dates } from 'context/DateProvider/DateProvider';
import { dateAxisDataItem } from 'features/Health/components/MonetisationHealthChart/utils/dateAxisDataItem';
import { PALETTE_BLUE_100 } from 'utils/colours';

const POSITION_X_KEY = 'positionX';
const SELECT_STARTED_EVENT = 'selectstarted';
const SELECT_ENDED_EVENT = 'selectended';
const FILL_SETTINGS = { fill: color(PALETTE_BLUE_100), fillOpacity: 1, visible: true };

const setNewDateTimeRange = (
  setDateTimeRange: ((value: ((prevState: Dates) => Dates) | Dates) => void) | undefined,
  startDate: Date,
  endDate: Date
) => {
  if (setDateTimeRange) {
    if (startDate > endDate) {
      [startDate, endDate] = [endDate, startDate];
    }
    setDateTimeRange((prevState) => ({
      ...prevState,
      from: startDate.toISOString(),
      to: endDate.toISOString(),
    }));
  }
};
const setXAxisGridFill = (xAxis: DateAxis<AxisRenderer>, startDate: Date, endDate: Date) => {
  const xAxisDataItem = dateAxisDataItem(xAxis, startDate, endDate);
  xAxis.createAxisRange(xAxisDataItem);
  xAxisDataItem.get('axisFill')?.setAll(FILL_SETTINGS);
  xAxisDataItem.get('grid')?.set('forceHidden', true);
};

const getDateFromXAxis = (cursor: XYCursor, date: Date, xAxis: DateAxis<AxisRenderer>) => {
  let posX = cursor.getPrivate(POSITION_X_KEY);
  if (posX) {
    date = xAxis.positionToDate(xAxis.toAxisPosition(posX));
  }
  return date;
};

export const setCursorSelectBehaviour = (
  dateTimeRange: Dates | undefined,
  cursor: XYCursor,
  xAxis: DateAxis<AxisRenderer>,
  setDateTimeRange: ((value: ((prevState: Dates) => Dates) | Dates) => void) | undefined
) => {
  let startDate: Date;
  let endDate: Date;

  if (dateTimeRange) {
    startDate = new Date(dateTimeRange.from);
    endDate = new Date(dateTimeRange.to);

    cursor.events.on(SELECT_STARTED_EVENT, () => {
      startDate = getDateFromXAxis(cursor, startDate, xAxis);
    });

    cursor.events.on(SELECT_ENDED_EVENT, () => {
      endDate = getDateFromXAxis(cursor, endDate, xAxis);
      setNewDateTimeRange(setDateTimeRange, startDate, endDate);
    });
    setXAxisGridFill(xAxis, startDate, endDate);
  }
};
